import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=47414d7a&scoped=true&"
import script from "./FormComponent.vue?vue&type=script&lang=ts&"
export * from "./FormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormComponent.vue?vue&type=style&index=0&id=47414d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47414d7a",
  null
  
)

export default component.exports